import React, { useEffect, useState } from 'react';
import { X, Copy, Check, Mail } from 'lucide-react';
import { useTheme } from '../../lib/theme';

const SUPPORT_EMAIL = 'support@clasifi.ca';

export default function ContactSupportCancelDialog({ onClose }) {
  const { colors } = useTheme();
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const onEsc = (e) => { if (e.key === 'Escape') onClose?.(); };
    window.addEventListener('keydown', onEsc);
    return () => window.removeEventListener('keydown', onEsc);
  }, [onClose]);

  const copyEmail = async () => {
    try { await navigator.clipboard.writeText(SUPPORT_EMAIL); setCopied(true); setTimeout(() => setCopied(false), 1600); }
    catch { /* ignore */ }
  };

  return (
    <div
      data-testid="cancel-dialog"
      role="dialog" aria-modal="true"
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, zIndex: 1000,
        background: 'rgba(10,10,10,0.55)', backdropFilter: 'blur(6px)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: colors.surface, borderRadius: 20, maxWidth: 460, width: '100%',
          padding: 28, boxShadow: '0 40px 100px -30px rgba(0,0,0,0.3)', position: 'relative',
        }}
      >
        <button
          onClick={onClose} data-testid="cancel-dialog-close" aria-label="Close"
          style={{ position: 'absolute', top: 14, right: 14, background: 'transparent', border: 'none', cursor: 'pointer', color: colors.textMuted, padding: 6 }}
        >
          <X size={18} />
        </button>
        <h3 style={{ margin: 0, fontSize: 22, fontWeight: 800, color: colors.text, letterSpacing: '-0.02em' }}>Cancellation</h3>
        <p style={{ marginTop: 10, color: colors.textMuted, fontSize: 14, lineHeight: 1.55 }}>
          Cancellations are handled by our team to make sure your data is handled correctly. Please email <strong style={{ color: colors.text }}>{SUPPORT_EMAIL}</strong> and we'll process it within 1 business day.
        </p>
        <div style={{ marginTop: 16, display: 'flex', gap: 8 }}>
          <a
            href={`mailto:${SUPPORT_EMAIL}?subject=Cancel%20my%20Clasifi%20subscription`}
            data-testid="cancel-dialog-mail"
            style={{
              flex: 1, textAlign: 'center', padding: '11px 16px', borderRadius: 10,
              background: colors.accent, color: 'white', textDecoration: 'none',
              fontWeight: 700, fontSize: 14, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 8,
              boxShadow: `0 10px 24px -14px ${colors.accent}`,
            }}
          >
            <Mail size={14} /> Email support
          </a>
          <button
            type="button" onClick={copyEmail}
            data-testid="cancel-dialog-copy"
            style={{
              padding: '11px 16px', borderRadius: 10,
              border: `1px solid ${colors.border}`, background: 'transparent', color: colors.text,
              fontWeight: 700, fontSize: 13, cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 6,
            }}
          >
            {copied ? <><Check size={14} color={colors.accent} /> Copied</> : <><Copy size={14} /> Copy</>}
          </button>
        </div>
      </div>
    </div>
  );
}
